module.exports = __webpack_public_path__ + "img/robot-mark.b83800ff.png";